import { FC, Fragment, useReducer } from 'react';

import { Plus } from 'lucide-react';
import { toast } from 'sonner';
import { mutate } from 'swr';
import useSWRMutation from 'swr/mutation';

import Button from '@mui/material/Button';

import { initialValues, PartnerSpotlightForm } from '../partnerSpotlights/partnerSpotlightFormDialog/form';
import { PartnerSpotlightFormDialog } from '../partnerSpotlights/partnerSpotlightFormDialog/PartnerSpotlightFormDialog';
import { mapFormToDto } from '../partnerSpotlights/partnerSpotlightFormDialog/utils';

import { partnerSpotlightService } from 'v2/api/partnerSpotlightService';
import { handleHttpError } from 'v2/utils';

export const CreatePartnerSpotlightButton: FC = () => {
  const [isOpen, setOpen] = useReducer((state) => !state, false);

  const { trigger, isMutating } = useSWRMutation(
    'createPartnerSpotlight',
    partnerSpotlightService.createPartnerSpotlight,
    {
      onSuccess: () => {
        mutate('getPartnerSpotlights');
        toast.success('Partner Spotlight has been successfully created');
        setOpen();
      },
      onError: handleHttpError,
    }
  );

  const handleSubmit = (values: PartnerSpotlightForm, resetForm: VoidFunction) => {
    trigger(mapFormToDto(values)).then(() => {
      resetForm();
    });
  };

  return (
    <Fragment>
      <Button onClick={setOpen} startIcon={<Plus />} variant="contained" size="large">
        Create Partner Spotlight
      </Button>

      <PartnerSpotlightFormDialog
        title="Create Partner Spotlight"
        isOpen={isOpen}
        onClose={setOpen}
        initialValues={initialValues}
        isSubmitting={isMutating}
        onSubmit={handleSubmit}
      />
    </Fragment>
  );
};
